import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '../../../assets/map/lineicon.png';
import _imports_1 from '../../../assets/map/lineiconon.png';
const _hoisted_1 = {
  class: "configContainer f3f3f6"
};
const _hoisted_2 = {
  class: "top-head"
};
const _hoisted_3 = {
  class: "top-list"
};
const _hoisted_4 = {
  class: "screenbtn"
};
const _hoisted_5 = {
  class: "rightbox"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  id: "map",
  class: "map_content",
  ref: "maps"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "toolbaredit"
};
const _hoisted_12 = {
  src: _imports_0,
  alt: ""
};
const _hoisted_13 = {
  src: _imports_1,
  alt: ""
};
const _hoisted_14 = {
  class: "drawdialog"
};
const _hoisted_15 = {
  class: "itembox"
};
const _hoisted_16 = {
  class: "outerLine"
};
const _hoisted_17 = {
  class: "dialog-footer"
};
const _hoisted_18 = {
  class: "screenswitch"
};
const _hoisted_19 = {
  class: "innercontent"
};
const _hoisted_20 = {
  class: "typeUl"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "innercontent"
};
const _hoisted_23 = {
  class: "addTophead"
};
const _hoisted_24 = {
  class: "dataul"
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  class: "txtbox"
};
const _hoisted_28 = {
  class: "paramsbox"
};
const _hoisted_29 = {
  class: "pageContainer detail"
};
const _hoisted_30 = {
  class: "operationcontainer"
};
const _hoisted_31 = {
  class: "title"
};
const _hoisted_32 = {
  class: "itemul"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = {
  class: "itemselect"
};
const _hoisted_35 = {
  class: "w48"
};
const _hoisted_36 = {
  class: "w48"
};
const _hoisted_37 = {
  class: "w48"
};
const _hoisted_38 = {
  class: "w48"
};
const _hoisted_39 = {
  class: "itemselect"
};
const _hoisted_40 = {
  class: "w48"
};
const _hoisted_41 = {
  class: "w48"
};
const _hoisted_42 = {
  class: ""
};
const _hoisted_43 = {
  class: "tabsul"
};
const _hoisted_44 = {
  class: "itemselect"
};
const _hoisted_45 = {
  class: "w48 mb10"
};
const _hoisted_46 = {
  class: "w100 mb10 bgbox"
};
const _hoisted_47 = {
  class: "txtbox"
};
const _hoisted_48 = ["src"];
const _hoisted_49 = {
  class: "el-upload-list__item-actions"
};
const _hoisted_50 = ["onClick"];
const _hoisted_51 = {
  class: "w100"
};
const _hoisted_52 = {
  class: "w100"
};
const _hoisted_53 = {
  class: "w100"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Setting = _resolveComponent("Setting");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_ArrowRight = _resolveComponent("ArrowRight");
  const _component_Document = _resolveComponent("Document");
  const _component_Monitor = _resolveComponent("Monitor");
  const _component_Iphone = _resolveComponent("Iphone");
  const _component_el_button = _resolveComponent("el-button");
  const _component_maptype = _resolveComponent("maptype");
  const _component_Delete = _resolveComponent("Delete");
  const _component_Close = _resolveComponent("Close");
  const _component_el_color_picker = _resolveComponent("el-color-picker");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_Plus = _resolveComponent("Plus");
  const _component_Minus = _resolveComponent("Minus");
  const _component_FullScreen = _resolveComponent("FullScreen");
  const _component_DArrowRight = _resolveComponent("DArrowRight");
  const _component_DArrowLeft = _resolveComponent("DArrowLeft");
  const _component_mapdata = _resolveComponent("mapdata");
  const _component_el_input = _resolveComponent("el-input");
  const _component_pointdata = _resolveComponent("pointdata");
  const _component_CircleClose = _resolveComponent("CircleClose");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[51] || (_cache[51] = _createElementVNode("a", {
    href: "javascript:void(0)",
    class: "back"
  }, null, -1)), _createElementVNode("ul", _hoisted_3, [_createElementVNode("li", {
    class: _normalizeClass({
      'active': $data.stepIndex === 0
    }),
    onClick: _cache[0] || (_cache[0] = $event => $options.navHandle(0))
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Setting)]),
    _: 1
  }), _cache[44] || (_cache[44] = _createTextVNode("地图设置"))], 2), _createVNode(_component_el_icon, {
    class: "arrow"
  }, {
    default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
    _: 1
  }), _createElementVNode("li", {
    class: _normalizeClass({
      'active': $data.stepIndex === 1
    }),
    onClick: _cache[1] || (_cache[1] = $event => $options.navHandle(1))
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Document)]),
    _: 1
  }), _cache[45] || (_cache[45] = _createTextVNode("分类设置"))], 2), _createVNode(_component_el_icon, {
    class: "arrow"
  }, {
    default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
    _: 1
  }), _createElementVNode("li", {
    class: _normalizeClass({
      'active': $data.stepIndex === 2
    }),
    onClick: _cache[2] || (_cache[2] = $event => $options.navHandle(2))
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Document)]),
    _: 1
  }), _cache[46] || (_cache[46] = _createTextVNode("地点设置"))], 2)]), _createElementVNode("ul", _hoisted_4, [_createElementVNode("li", {
    onClick: _cache[3] || (_cache[3] = $event => $options.screenswitch(0)),
    class: _normalizeClass({
      'on': $data.screenIndex === 0
    })
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Monitor)]),
    _: 1
  }), _cache[47] || (_cache[47] = _createElementVNode("p", null, "电脑", -1))], 2), _createElementVNode("li", {
    onClick: _cache[4] || (_cache[4] = $event => $options.screenswitch(1)),
    class: _normalizeClass({
      'on': $data.screenIndex === 1
    })
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Iphone)]),
    _: 1
  }), _cache[48] || (_cache[48] = _createElementVNode("p", null, "手机", -1))], 2)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
    onClick: $options.saveHandle
  }, {
    default: _withCtx(() => _cache[49] || (_cache[49] = [_createTextVNode("保存")])),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    type: "primary",
    onClick: $options.releaseHandle
  }, {
    default: _withCtx(() => _cache[50] || (_cache[50] = [_createTextVNode("发布")])),
    _: 1
  }, 8, ["onClick"])])]), _createElementVNode("div", {
    class: _normalizeClass(["mainContainer", {
      'show': !$data.showRightslide
    }])
  }, [_createElementVNode("div", {
    class: _normalizeClass(["maindragbox", {
      'mobile': !$data.isPc
    }]),
    onMousedown: _cache[8] || (_cache[8] = (...args) => $options.screenmousedown && $options.screenmousedown(...args))
  }, [_createElementVNode("div", {
    class: "maininnerbox",
    ref: "maininnerbox",
    style: _normalizeStyle($data.maininnerStyle)
  }, [_withDirectives(_createElementVNode("img", {
    class: "mapbg",
    src: $data.mpcdata.background_img,
    alt: ""
  }, null, 8, _hoisted_6), [[_vShow, $data.isPc && $data.mpcdata.background_img]]), _withDirectives(_createElementVNode("img", {
    class: "mapbg",
    src: $data.mpcdata.app_bg_img,
    alt: ""
  }, null, 8, _hoisted_7), [[_vShow, !$data.isPc && $data.mpcdata.app_bg_img]]), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["logo", [{
      'active': $data.styleDialog && $data.elemName === 'logo'
    }, {
      'mobile': !$data.isPc
    }, `fid${$data.fid}`]]),
    style: _normalizeStyle($data.jsonOption.logo),
    onClick: _cache[5] || (_cache[5] = $event => $options.styleHandle('logo'))
  }, [_createElementVNode("img", {
    src: $data.mpcdata.logo,
    alt: ""
  }, null, 8, _hoisted_8)], 6), [[_vShow, $data.mpcdata.logo]]), _createElementVNode("div", _hoisted_9, null, 512), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["pickey", [{
      'active': $data.styleDialog && $data.elemName === 'pickey'
    }, {
      'mobile': !$data.isPc
    }, `fid${$data.fid}`]]),
    style: _normalizeStyle($data.jsonOption.pickey),
    onClick: _cache[6] || (_cache[6] = $event => $options.styleHandle('pickey'))
  }, [_createElementVNode("img", {
    src: $data.mpcdata.pickey,
    alt: ""
  }, null, 8, _hoisted_10)], 6), [[_vShow, $data.mpcdata.pickey]]), $data.typeshow ? (_openBlock(), _createBlock(_component_maptype, {
    key: 0,
    class: _normalizeClass([`fid${$data.fid}`]),
    typedata: $data.typeArr,
    styleDialog: $data.styleDialog,
    elemName: $data.elemName,
    jsonOption: $data.jsonOption,
    typemodel: $data.typemodel,
    currentType: $data.currentType,
    ispc: !$data.isPc,
    onStypeClick: _cache[7] || (_cache[7] = $event => $options.styleHandle('typenav'))
  }, null, 8, ["class", "typedata", "styleDialog", "elemName", "jsonOption", "typemodel", "currentType", "ispc"])) : _createCommentVNode("", true)], 4)], 34), _withDirectives(_createElementVNode("ul", {
    class: "toolbar",
    onMouseleave: _cache[10] || (_cache[10] = (...args) => $options.hoverOutHandle && $options.hoverOutHandle(...args))
  }, [_createElementVNode("li", {
    onClick: _cache[9] || (_cache[9] = (...args) => _ctx.setStyle && _ctx.setStyle(...args))
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Setting)]),
    _: 1
  })])], 544), [[_vShow, $data.toolbarflag]])], 2), _createElementVNode("div", _hoisted_11, [_createElementVNode("ul", null, [_createElementVNode("li", {
    onClick: _cache[11] || (_cache[11] = $event => $options.addInteraction('LineString'))
  }, [_withDirectives(_createElementVNode("img", _hoisted_12, null, 512), [[_vShow, !$data.linefoucs]]), _withDirectives(_createElementVNode("img", _hoisted_13, null, 512), [[_vShow, $data.linefoucs]])]), _createElementVNode("li", {
    onClick: _cache[12] || (_cache[12] = (...args) => $options.clearDraw && $options.clearDraw(...args)),
    class: "save"
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Delete)]),
    _: 1
  })])])]), _withDirectives(_createElementVNode("div", _hoisted_14, [_createElementVNode("h2", null, [_cache[52] || (_cache[52] = _createTextVNode("标绘线")), _createVNode(_component_el_icon, {
    onClick: $options.drawQuit
  }, {
    default: _withCtx(() => [_createVNode(_component_Close)]),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_15, [_cache[56] || (_cache[56] = _createElementVNode("h3", null, "外观", -1)), _createElementVNode("ul", _hoisted_16, [_createElementVNode("li", null, [_cache[53] || (_cache[53] = _createElementVNode("span", null, "颜色", -1)), _createVNode(_component_el_color_picker, {
    modelValue: $data.lineform.color,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.lineform.color = $event),
    size: "small",
    onChange: $options.drawLineChange
  }, null, 8, ["modelValue", "onChange"])]), _createElementVNode("li", null, [_cache[54] || (_cache[54] = _createElementVNode("span", null, "大小", -1)), _createVNode(_component_el_select, {
    modelValue: $data.lineform.size,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.lineform.size = $event),
    class: "m-2",
    placeholder: "Select",
    size: "small",
    onChange: $options.drawLineChange
  }, {
    default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (item, index) => {
      return _createVNode(_component_el_option, {
        key: index,
        value: index + 1
      }, null, 8, ["value"]);
    }), 64))]),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createElementVNode("li", null, [_cache[55] || (_cache[55] = _createElementVNode("span", null, "样式", -1)), _createVNode(_component_el_select, {
    modelValue: $data.lineform.style,
    "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.lineform.style = $event),
    class: "m-2",
    placeholder: "请选择",
    size: "small",
    onChange: $options.drawLineChange
  }, {
    default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (item, index) => {
      return _createVNode(_component_el_option, {
        key: index,
        value: index + 1
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(["solidIcon", `icon${index + 1}`])
        }, null, 2)]),
        _: 2
      }, 1032, ["value"]);
    }), 64))]),
    _: 1
  }, 8, ["modelValue", "onChange"])])])]), _cache[59] || (_cache[59] = _createElementVNode("div", {
    class: "desc"
  }, "确定保存绘制线段么？", -1)), _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_button, {
    onClick: $options.drawQuit
  }, {
    default: _withCtx(() => _cache[57] || (_cache[57] = [_createTextVNode("取消")])),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    type: "primary",
    onClick: $options.saveDraw
  }, {
    default: _withCtx(() => _cache[58] || (_cache[58] = [_createTextVNode("确认")])),
    _: 1
  }, 8, ["onClick"])])], 512), [[_vShow, $data.dialogVisible]]), _createElementVNode("div", _hoisted_18, [_createElementVNode("ul", null, [_createElementVNode("li", {
    onClick: _cache[16] || (_cache[16] = (...args) => $options.plusScale && $options.plusScale(...args))
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Plus)]),
    _: 1
  })]), _createElementVNode("li", null, _toDisplayString($data.screenvalue) + "%", 1), _createElementVNode("li", {
    onClick: _cache[17] || (_cache[17] = (...args) => $options.minusScale && $options.minusScale(...args))
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Minus)]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_FullScreen)]),
    _: 1
  })])])]), _createElementVNode("div", {
    class: _normalizeClass(["pageContainer", {
      'hide': !$data.showRightslide
    }])
  }, [_createElementVNode("div", {
    class: "rightswitch",
    onClick: _cache[18] || (_cache[18] = (...args) => $options.switchRight && $options.switchRight(...args))
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_withDirectives(_createVNode(_component_DArrowRight, null, null, 512), [[_vShow, $data.showRightslide]]), _withDirectives(_createVNode(_component_DArrowLeft, null, null, 512), [[_vShow, !$data.showRightslide]])]),
    _: 1
  })]), _withDirectives(_createVNode(_component_mapdata, {
    ref: "mdComp",
    mtObj: $data.mtObj,
    onUpdateMap: $options.updateMap,
    onIsAddOrEdit: $options.aoeStatus,
    onLeveloptions: $options.getdatalevel,
    ispc: !$data.isPc,
    elemName: $data.elemName
  }, null, 8, ["mtObj", "onUpdateMap", "onIsAddOrEdit", "onLeveloptions", "ispc", "elemName"]), [[_vShow, $data.stepIndex === 0]]), _withDirectives(_createElementVNode("div", _hoisted_19, [_createElementVNode("ul", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.typeArr, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index
    }, [_createVNode(_component_el_input, {
      modelValue: item.value,
      "onUpdate:modelValue": $event => item.value = $event,
      onBlur: $event => $options.blurInput($event, index),
      disabled: item.disabled
    }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "disabled"]), _createElementVNode("div", {
      class: "iconbtn minus",
      onClick: $event => $options.deleteType(index)
    }, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_Minus)]),
      _: 1
    })], 8, _hoisted_21)]);
  }), 128)), _createElementVNode("div", {
    class: "iconbtn plus",
    onClick: _cache[19] || (_cache[19] = (...args) => $options.addType && $options.addType(...args))
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Plus)]),
    _: 1
  })])])], 512), [[_vShow, $data.stepIndex === 1]]), _withDirectives(_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createVNode(_component_el_button, {
    type: "primary",
    onClick: $options.addDataHandle
  }, {
    default: _withCtx(() => _cache[60] || (_cache[60] = [_createTextVNode("添加")])),
    _: 1
  }, 8, ["onClick"]), _createElementVNode("p", null, "共" + _toDisplayString($data.dataList.length) + "条", 1)]), _createElementVNode("ul", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dataList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass({
        'active': $data.currentLiIndex === index
      }),
      key: index,
      onClick: $event => $options.dataliHandle(item, index)
    }, [item.itemformdata[4].length > 0 ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: item.itemformdata[4][0].fileUrl,
      alt: ""
    }, null, 8, _hoisted_26)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_27, [_createElementVNode("h2", null, _toDisplayString(item.itemformdata.placeName), 1), _createElementVNode("div", _hoisted_28, [_createElementVNode("p", null, "层级 " + _toDisplayString(item.itemformdata.mapLevel), 1), _withDirectives(_createElementVNode("p", null, _toDisplayString(item.itemformdata.mapType), 513), [[_vShow, item.itemformdata.mapType !== '']])])])], 10, _hoisted_25);
  }), 128))])], 512), [[_vShow, $data.stepIndex === 2]])], 2), _withDirectives(_createElementVNode("div", _hoisted_29, [_withDirectives(_createVNode(_component_pointdata, {
    ref: "pointComp",
    mtObj: $data.mtObj,
    isAddDataflag: $data.isAddDataflag,
    typeArr: $data.typeArr,
    leveloptions: $data.dataleveloption,
    onGoback: $options.gobacktype,
    detail: $data.detailObj,
    mapconfigData: $data.mpcdata,
    onSuccess: $options.successHandle
  }, null, 8, ["mtObj", "isAddDataflag", "typeArr", "leveloptions", "onGoback", "detail", "mapconfigData", "onSuccess"]), [[_vShow, $data.detailflag]])], 512), [[_vShow, $data.detailflag]]), _withDirectives(_createElementVNode("div", _hoisted_30, [_createElementVNode("h2", _hoisted_31, [_cache[61] || (_cache[61] = _createTextVNode("样式配置")), _createVNode(_component_el_icon, {
    onClick: _cache[20] || (_cache[20] = $event => $data.styleDialog = false)
  }, {
    default: _withCtx(() => [_createVNode(_component_CircleClose)]),
    _: 1
  })]), _createVNode(_component_el_form, {
    "label-position": "top",
    "label-width": "100px",
    style: {
      "max-width": "460px"
    }
  }, {
    default: _withCtx(() => [_cache[77] || (_cache[77] = _createElementVNode("label", null, "定位", -1)), _createElementVNode("ul", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.compt.absoluteArr, (item, index) => {
      return _openBlock(), _createElementBlock("li", {
        key: index,
        class: _normalizeClass({
          'on': $data.compt.absoluteArrindex === index
        }),
        onClick: $event => $options.absolutechange(index)
      }, [_createVNode(_component_el_tooltip, {
        effect: "dark",
        content: item.text,
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          class: _normalizeClass(item.icon)
        }, null, 2)]),
        _: 2
      }, 1032, ["content"])], 10, _hoisted_33);
    }), 128))]), _createElementVNode("div", _hoisted_34, [_withDirectives(_createElementVNode("div", _hoisted_35, [_cache[62] || (_cache[62] = _createElementVNode("label", null, "距右边", -1)), _createVNode(_component_el_input_number, {
      modelValue: $data.styleform.right,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.styleform.right = $event),
      class: "mx-4",
      min: 0,
      "controls-position": "right",
      onChange: _cache[22] || (_cache[22] = $event => $options.csshandleChange('right'))
    }, null, 8, ["modelValue"])], 512), [[_vShow, $data.compt.absoluteArrindex === 1 || $data.compt.absoluteArrindex === 3]]), _withDirectives(_createElementVNode("div", _hoisted_36, [_cache[63] || (_cache[63] = _createElementVNode("label", null, "距左边", -1)), _createVNode(_component_el_input_number, {
      modelValue: $data.styleform.left,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.styleform.left = $event),
      class: "mx-4",
      min: 0,
      "controls-position": "right",
      onChange: _cache[24] || (_cache[24] = $event => $options.csshandleChange('left'))
    }, null, 8, ["modelValue"])], 512), [[_vShow, $data.compt.absoluteArrindex === 0 || $data.compt.absoluteArrindex === 2]]), _withDirectives(_createElementVNode("div", _hoisted_37, [_cache[64] || (_cache[64] = _createElementVNode("label", null, "距上边", -1)), _createVNode(_component_el_input_number, {
      modelValue: $data.styleform.top,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => $data.styleform.top = $event),
      class: "mx-4",
      min: 0,
      "controls-position": "right",
      onChange: _cache[26] || (_cache[26] = $event => $options.csshandleChange('top'))
    }, null, 8, ["modelValue"])], 512), [[_vShow, $data.compt.absoluteArrindex === 0 || $data.compt.absoluteArrindex === 1]]), _withDirectives(_createElementVNode("div", _hoisted_38, [_cache[65] || (_cache[65] = _createElementVNode("label", null, "距下边", -1)), _createVNode(_component_el_input_number, {
      modelValue: $data.styleform.bottom,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => $data.styleform.bottom = $event),
      class: "mx-4",
      min: 0,
      "controls-position": "right",
      onChange: _cache[28] || (_cache[28] = $event => $options.csshandleChange('bottom'))
    }, null, 8, ["modelValue"])], 512), [[_vShow, $data.compt.absoluteArrindex === 2 || $data.compt.absoluteArrindex === 3]])]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_cache[66] || (_cache[66] = _createElementVNode("span", {
      class: "spantext"
    }, "宽度", -1)), _createVNode(_component_el_input_number, {
      modelValue: $data.styleform.width,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => $data.styleform.width = $event),
      class: "mx-4",
      min: 0,
      "controls-position": "right",
      onChange: _cache[30] || (_cache[30] = $event => $options.csshandleChange('width'))
    }, null, 8, ["modelValue"])]), _withDirectives(_createElementVNode("div", _hoisted_41, [_cache[67] || (_cache[67] = _createElementVNode("span", {
      class: "spantext"
    }, "高度", -1)), _createVNode(_component_el_input_number, {
      modelValue: $data.styleform.height,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => $data.styleform.height = $event),
      class: "mx-4",
      min: 0,
      "controls-position": "right",
      onChange: _cache[32] || (_cache[32] = $event => $options.csshandleChange('height'))
    }, null, 8, ["modelValue"])], 512), [[_vShow, $data.compt.heightflag]])]), _withDirectives(_createElementVNode("div", _hoisted_42, [_cache[76] || (_cache[76] = _createElementVNode("label", null, "分类", -1)), _createElementVNode("ul", _hoisted_43, [_createElementVNode("li", {
      onClick: _cache[33] || (_cache[33] = $event => $options.typeUlclick(0)),
      class: _normalizeClass({
        'on': $data.typeUlIndex === 0
      })
    }, "默认", 2), _createElementVNode("li", {
      onClick: _cache[34] || (_cache[34] = $event => $options.typeUlclick(1)),
      class: _normalizeClass({
        'on': $data.typeUlIndex === 1
      })
    }, "点击/鼠标滑过", 2)]), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_cache[68] || (_cache[68] = _createElementVNode("span", {
      class: "spantext"
    }, "高度", -1)), _createVNode(_component_el_input_number, {
      modelValue: $data.otherform.height,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => $data.otherform.height = $event),
      class: "mx-4",
      min: 40,
      "controls-position": "right",
      onChange: _cache[36] || (_cache[36] = $event => $options.othercsshandleChange('height'))
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_46, [_cache[72] || (_cache[72] = _createElementVNode("span", {
      class: "spantext"
    }, "背景图片", -1)), _createVNode(_component_el_upload, {
      class: "uploadbox",
      "file-list": $data.otherform.backgroundfile,
      "onUpdate:fileList": _cache[37] || (_cache[37] = $event => $data.otherform.backgroundfile = $event),
      "list-type": "picture",
      "auto-upload": false,
      action: "#",
      "before-upload": $options.beforeAvatarUpload,
      "on-change": $options.uploadChange,
      limit: 1
    }, {
      file: _withCtx(({
        file
      }) => [_createElementVNode("div", null, [_createElementVNode("img", {
        class: "el-upload-list__item-thumbnail",
        src: file.url,
        alt: ""
      }, null, 8, _hoisted_48), _createElementVNode("span", _hoisted_49, [_createElementVNode("span", {
        class: "el-upload-list__item-delete",
        onClick: $event => $options.handleRemove(file)
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Delete)]),
        _: 1
      })], 8, _hoisted_50)])])]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_47, [_cache[70] || (_cache[70] = _createElementVNode("p", null, "格式：PNG/JPG/GIF", -1)), _cache[71] || (_cache[71] = _createElementVNode("p", null, "大小：1M以下", -1)), _withDirectives(_createVNode(_component_el_button, null, {
        default: _withCtx(() => _cache[69] || (_cache[69] = [_createTextVNode("上传")])),
        _: 1
      }, 512), [[_vShow, $data.otherform.backgroundImage === undefined || $data.otherform.backgroundImage === '']])])]),
      _: 1
    }, 8, ["file-list", "before-upload", "on-change"])]), _createElementVNode("div", _hoisted_51, [_cache[73] || (_cache[73] = _createElementVNode("span", {
      class: "spantext"
    }, "背景颜色", -1)), _createVNode(_component_el_color_picker, {
      modelValue: $data.otherform.backgroundColor,
      "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => $data.otherform.backgroundColor = $event),
      "show-alpha": "",
      onChange: _cache[39] || (_cache[39] = $event => $options.othercsshandleChange('backgroundColor'))
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_52, [_cache[74] || (_cache[74] = _createElementVNode("span", {
      class: "spantext"
    }, "文字颜色", -1)), _createVNode(_component_el_color_picker, {
      modelValue: $data.otherform.color,
      "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => $data.otherform.color = $event),
      "show-alpha": "",
      onChange: _cache[41] || (_cache[41] = $event => $options.othercsshandleChange('color'))
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_53, [_cache[75] || (_cache[75] = _createElementVNode("span", {
      class: "spantext"
    }, "文字大小", -1)), _createVNode(_component_el_input_number, {
      modelValue: $data.otherform.fontSize,
      "onUpdate:modelValue": _cache[42] || (_cache[42] = $event => $data.otherform.fontSize = $event),
      class: "mx-4",
      min: 12,
      "controls-position": "right",
      onChange: _cache[43] || (_cache[43] = $event => $options.othercsshandleChange('fontSize'))
    }, null, 8, ["modelValue"])])])], 512), [[_vShow, $data.elemName === 'typenav']])]),
    _: 1
  })], 512), [[_vShow, $data.styleDialog]])]);
}